import { render, staticRenderFns } from "./cnvResult.vue?vue&type=template&id=4e2cb6de&scoped=true"
import script from "./cnvResult.vue?vue&type=script&lang=js"
export * from "./cnvResult.vue?vue&type=script&lang=js"
import style0 from "./cnvResult.vue?vue&type=style&index=0&id=4e2cb6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2cb6de",
  null
  
)

export default component.exports